// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--11-0!./node_modules/vue-style-loader!./node_modules/css-loader/dist/cjs.js??ref--11-2!./node_modules/postcss-loader/src??ref--11-3!./node_modules/sass-loader/dist/cjs.js??ref--11-4!./scss/style.scss
// module id = wRWH
// module chunks = 0